import React from 'react';
import { useTranslation } from '../../services';
import Select from '../Select';
import { COMPANY_TYPES } from '../../constants';

export const CompanyTypeFilter = ({
    onChange
}) => {
    const { t } = useTranslation();

    const getData = () => ([{
        name: t('companies.all'),
        id: COMPANY_TYPES.all
    }, {
        name: t('companies.leads'),
        id: COMPANY_TYPES.leads
    }, {
        name: t('companies.customers'),
        id: COMPANY_TYPES.customers
    }]);

    return (
        <Select
            data={getData()}
            onChange={onChange}
            defaultValue={COMPANY_TYPES.all}
        />
    )
};
